export class UserConstants {
  public static readonly usernameMaxLength: number = 255;
  public static readonly firstnameMaxLength: number = 255;
  public static readonly lastnameMaxLength: number = 255;
  public static readonly phoneNumberMaxLength: number = 64;
}
